const URL_TESLA_OAUTH = "https://owner-api.teslamotors.com/oauth";

class TeslaOAuthApi {

  static authenticateEmailPassword(email, password) {
	  var json = {};
	  json.grant_type = 'password';
	  json.client_id = '81527cff06843c8634fdc09e8ac0abefb46ac849f38fe1e431c2ef2106796384';
	  json.client_secret = 'c7257eb71a564034f9419ee651c7d0e5f7aa6bfbd18bafb5c5c033b093bb2fa3';
	  json.email = email;
	  json.password = password;
	  
	  var data = '';
	  data += 'grant_type=password';
	  data += '&client_id=81527cff06843c8634fdc09e8ac0abefb46ac849f38fe1e431c2ef2106796384';
	  data += '&client_secret=c7257eb71a564034f9419ee651c7d0e5f7aa6bfbd18bafb5c5c033b093bb2fa3';
	  data += '&email=' + encodeURIComponent(email);
	  data += '&password=' + encodeURIComponent(password);
	  
	  console.log(data);
	  
	  // Use application/x-www-form-urlencoded to avoid CORS preflight check.
	  // Tesla API does not respond to OPTIONS.
    const headers = {'Content-Type': 'application/x-www-form-urlencoded'};
    const request = new Request(`${URL_TESLA_OAUTH}/token`, {
      method: 'POST',
      headers: headers,
      body: data
    });

    return fetch(request).then(response => {
		return response.json();
    }).catch(error => {
		console.log(error);
      return error;
    });
  }
}

export default TeslaOAuthApi;


// WEBPACK FOOTER //
// ./src/api/teslaOAuthApi.js